import { IAdminGroup } from '../../../../../store/admin/groups/store';
import { ISelectedGroups } from '../InvitePlayers';

type TSelectAllGroups = (selectedGroups: ISelectedGroups, groups: IAdminGroup[]) => ISelectedGroups;

export const selectAllGroups: TSelectAllGroups = (selectedGroups, groups) => ({
  ...selectedGroups,
  ...groups.reduce(
    (
      acc: {
        [key: number]: boolean;
      },
      group: IAdminGroup
    ) => ({
      ...acc,
      [group.id]: false
    }),
    {}
  )
});
